module.exports = __webpack_public_path__ + "static/media/Access-Managment.86239b51.svg";